export interface IntegrationIcon {
  name: string
  icon: string
}

/**
 * Maps integration provider codes to their display names and icon identifiers
 * @param provider - The provider code from the event data
 * @returns IntegrationIcon object with name and icon, or null if provider not found
 */
export function getIntegrationIcon(provider: string): IntegrationIcon | null {
  switch (provider) {
    case 'tixr-new':
      return {
        name: 'Tixr New',
        icon: 'tixr-new',
      }
    case 'tixr':
      return {
        name: 'Tixr',
        icon: 'tixr',
      }
    case 'eventbrite':
      return {
        name: 'Eventbrite',
        icon: 'eventbrite',
      }
    case 'facebook':
      return {
        name: 'Facebook',
        icon: 'facebook',
      }
    case 'google':
      return {
        name: 'Google',
        icon: 'google',
      }
    case 'mailchimp':
      return {
        name: 'Mailchimp',
        icon: 'mailchimp',
      }
    case 'shopify':
      return {
        name: 'Shopify',
        icon: 'shopify',
      }
    case 'stripe':
      return {
        name: 'Stripe',
        icon: 'stripe',
      }
    case 'zoom':
      return {
        name: 'Zoom',
        icon: 'zoom',
      }
    case 'ticketek':
      return {
        name: 'Ticketek',
        icon: 'ticketek',
      }
    case 'dice':
      return {
        name: 'Dice',
        icon: 'dice',
      }
    case 'event-genius':
      return {
        name: 'Event Genius',
        icon: 'event-genius',
      }
    case 'eventix':
      return {
        name: 'Eventix',
        icon: 'eventix',
      }
    case 'humanitix':
      return {
        name: 'Humanitix',
        icon: 'humanitix',
      }
    case 'memberful':
      return {
        name: 'Memberful',
        icon: 'memberful',
      }
    case 'moshtix':
      return {
        name: 'Moshtix',
        icon: 'moshtix',
      }
    case 'patreon':
      return {
        name: 'Patreon',
        icon: 'patreon',
      }
    case 'universe':
      return {
        name: 'Universe',
        icon: 'universe',
      }
    case 'axs':
      return {
        name: 'AXS',
        icon: 'axs',
      }
    case 'showclix':
      return {
        name: 'ShowClix',
        icon: 'showclix',
      }
    case 'ticketmaster':
      return {
        name: 'Ticketmaster',
        icon: 'ticketmaster',
      }
    case 'see-tickets-us':
      return {
        name: 'See Tickets US',
        icon: 'see-tickets-us',
      }
    default:
      return null
  }
}
